import { render, staticRenderFns } from "./goodProducts.vue?vue&type=template&id=4c71a808&scoped=true&"
import script from "./goodProducts.vue?vue&type=script&lang=js&"
export * from "./goodProducts.vue?vue&type=script&lang=js&"
import style0 from "./goodProducts.vue?vue&type=style&index=0&id=4c71a808&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c71a808",
  null
  
)

export default component.exports